import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames/bind";
import styles from "./NotFoundPage.module.scss";

const cx = classNames.bind(styles);

function NotFoundPage() {
  const [consoleText, setConsoleText] = useState("");

  useEffect(() => {
    const text = "SYSTEM ERROR: PAGE NOT FOUND...";
    let index = 0;
    const interval = setInterval(() => {
      setConsoleText((prev) => prev + text[index]);
      index++;
      if (index === text.length) clearInterval(interval);
    }, 100);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={cx("wrapper")}>
      <div className={cx("scanline")}></div>
      <h1 className={cx("title-page")}>404 - Không tìm thấy trang</h1>
      <p className={cx("console-text")}>{consoleText}</p>
      <p className={cx("description")}>Trang bạn đang tìm không tồn tại.</p>
      <Link to="/" className={cx("home-link")}>Quay về trang chủ</Link>
    </div>
  );
}

export default NotFoundPage;
